import { render, staticRenderFns } from "./SimpleCompanyAddModule.vue?vue&type=template&id=cbf95752&scoped=true&"
import script from "./SimpleCompanyAddModule.vue?vue&type=script&lang=js&"
export * from "./SimpleCompanyAddModule.vue?vue&type=script&lang=js&"
import style0 from "./SimpleCompanyAddModule.vue?vue&type=style&index=0&id=cbf95752&prod&scoped=true&lang=scss&"
import style1 from "./SimpleCompanyAddModule.vue?vue&type=style&index=1&id=cbf95752&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf95752",
  null
  
)

export default component.exports